import { AdminCard } from "./AdminCard";

interface AdminInfoCardProps {
  title: string;
  description: string;
  icon?: string;
  tone?: "amber" | "blue" | "slate";
}

const iconToneClass = {
  amber: "text-amber-600",
  blue: "text-blue-600",
  slate: "text-slate-500",
};

const AdminInfoCard = ({ title, description, icon = "ri-information-line", tone = "amber" }: AdminInfoCardProps) => {
  return (
    <AdminCard padded>
      <div className="flex items-center gap-1.5 mb-2">
        <i className={`${icon} ${iconToneClass[tone]} text-xs`} />
        <h4 className="text-xs font-semibold text-slate-700">{title}</h4>
      </div>
      <p className="text-xs text-slate-500 leading-relaxed" style={{ wordBreak: "keep-all" }}>
        {description}
      </p>
    </AdminCard>
  );
};

export default AdminInfoCard;
